import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import T from 'components/common/text/T';
// import { size, toArray } from 'lodash';
import { useDidUpdateEffect, useShallowSelector } from 'lib/utils';
import { NavLink, useLocation, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { pageUrl } from 'lib/mapper';
import { color } from 'styles/utils';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton, Grid, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import cx from 'classnames';
import CustomSpan from 'components/common/text/CustomSpan';
import { AppActions } from 'store/actionCreators';

export default React.memo(function ProgressGroupRow({ groupData }) {
  const [expand, setExpand] = useState(true);
  const [uploadListCt, setUploadListCt] = useState({});
  const [downloadListCt, setDownloadListCt] = useState({});

  useEffect(() => {
    // console.log('groupData ____ ', groupData);
    const downloadFileArr = groupData.files.filter(item => {
      return item.type === 'download';
    });
    const uploadFileArr = groupData.files.filter(item => {
      return item.type === 'upload';
    });
    // console.log('downloadFileArr __ ', downloadFileArr);
    // console.log('uploadFileArr __ ', uploadFileArr);
    setUploadListCt(uploadFileArr);
    setDownloadListCt(downloadFileArr);
  }, [groupData]);

  // useEffect(() => {
  //   console.log('uploadListCt __ ', uploadListCt);
  // }, [uploadListCt]);

  // useEffect(() => {
  //   console.log('downloadListCt __ ', downloadListCt);
  // }, [downloadListCt]);

  const handleDeleteError = file => {
    // console.log('file _____ ', file);
    //     id: "c69cc097-b63b-48b7-92d1-4b3487434497"
    // progress: 0
    // projectCode: "4177c9c49f1347f2b50343b4b2546e43"
    // projectId: "20220302-toxnsldxn-nate-Invit-0000"
    // status: 0
    // type: "upload"

    AppActions.remove_upload_file_progress({ id: file.id });
  };

  if (!groupData) return;

  return (
    <Styled.ProgressListRow data-component-name="ProgressGropuRow">
      <Accordion
        expanded={Boolean(expand)}
        square
        className={cx('progressGroupRow__wrapper', {
          active: expand,
        })}
        // onClick={() => {
        //   setExpand(!expand);
        // }}
      >
        <AccordionSummary
          className="progressGroupRow__summary"
          onClick={() => {
            setExpand(!expand);
          }}
        >
          <CustomSpan>{groupData?.projectInfo.projectId}</CustomSpan>

          {!expand ? (
            <ExpandMoreIcon style={{ fontSize: '20px' }} />
          ) : (
            <ExpandLessIcon style={{ fontSize: '20px' }} />
          )}
        </AccordionSummary>

        <AccordionDetails className={cx('progressGroupRow__detail_box', {})}>
          {uploadListCt.length > 0 && (
            <div className="progressGroupRow__detail upload">
              <p className="progressGroupRow__detail_title upload">
                <T>UPLOAD</T>
              </p>
              <ul className="progressGroupRow__item_list">
                {uploadListCt?.map(item => {
                  let fileName = item.file.name;
                  return (
                    <NavLink to={`/project/detail/${item.projectCode}`} key={item.id}>
                      <li className="progressGroupRow__item_row ">
                        {/* http://localhost:3000/project/detail/4b939fb768439f498106142744981896 */}
                        <div className="progressGroupRow__item ">
                          <div
                            className={cx('progressGroupRow__uploadProgress_bar ', {
                              error: item?.error,
                            })}
                          >
                            <div
                              className={cx('', { error: item?.error })}
                              style={{ width: `${item.progress}%` }}
                            />
                          </div>
                          <p
                            className={cx('progressGroupRow__item_name ', {
                              error: item?.error,
                            })}
                            title={fileName}
                          >
                            {fileName}
                          </p>
                          {!!item?.error?.message && (
                            <p className="progressGroupRow__item_error " title={item.error.message}>
                              Message:{' '}
                              {item.error.message === 'OUT_OF_STORAGE'
                                ? 'The capacity has been exceeded.'
                                : item.error.message}
                            </p>
                          )}
                        </div>
                        <div className="progressGroupRow__status">
                          {/* <span className="progressGroupRow__item_percentage ">{item.progress}%</span> */}
                          {!!item?.error ? (
                            <IconButton
                              className="progressGroupRow__error_clear"
                              onClick={e => {
                                e.preventDefault();
                                handleDeleteError(item);
                              }}
                            >
                              <CloseIcon style={{ fontSize: '20px' }} />
                            </IconButton>
                          ) : (
                            //     <span className="progressGroupRow__error_clear_box">
                            // </span>
                            <span className="progressGroupRow__item_percentage ">
                              {item.progress}%
                            </span>
                          )}
                        </div>
                      </li>
                    </NavLink>
                  );
                })}
              </ul>
            </div>
          )}

          {downloadListCt.length > 0 && (
            <div className="progressGroupRow__detail download">
              <p className="progressGroupRow__detail_title download">
                <T>DOWNLOAD</T>
              </p>
              <ul className="progressGroupRow__item_list">
                {downloadListCt?.map(item => {
                  // console.log('item ___ ', item);
                  let fileName = item.file.name;
                  return (
                    <NavLink to={`/project/detail/${item.projectCode}`} key={item.id}>
                      <li className="progressGroupRow__item_row">
                        <div className="progressGroupRow__item ">
                          <div
                            className={cx('progressGroupRow__uploadProgress_bar ', {
                              error: item?.error,
                            })}
                          >
                            <div
                              className={cx('', { error: item?.error })}
                              style={{ width: `${item.progress}%` }}
                            />
                          </div>
                          <p
                            className={cx('progressGroupRow__item_name ', {
                              error: item?.error,
                            })}
                            title={fileName}
                          >
                            {fileName}
                          </p>
                          {!!item?.error?.message && (
                            <p className="progressGroupRow__item_error " title={item.error.message}>
                              Message:{' '}
                              {item.error.message === 'OUT_OF_STORAGE'
                                ? 'The capacity has been exceeded.'
                                : item.error.message}
                            </p>
                          )}
                        </div>
                        <div className="progressGroupRow__status">
                          {/* <span className="progressGroupRow__item_percentage ">{item.progress}%</span> */}
                          {!!item?.error ? (
                            <span className="progressGroupRow__error_clear_box">
                              <IconButton
                                className="progressGroupRow__error_clear"
                                onClick={e => {
                                  e.preventDefault();
                                  handleDeleteError(item);
                                }}
                              >
                                <CloseIcon style={{ fontSize: '20px' }} />
                              </IconButton>
                            </span>
                          ) : (
                            <span className="progressGroupRow__item_percentage ">
                              {item.progress}%
                            </span>
                          )}
                        </div>
                      </li>
                    </NavLink>
                  );
                })}
              </ul>
            </div>
          )}
        </AccordionDetails>
      </Accordion>
    </Styled.ProgressListRow>
  );
});

const Styled = {
  ProgressListRow: styled.li`
    .progressGroupRow__wrapper {
      width: 100%;
      border-bottom: 1px solid #e7e8f2;

      min-height: 30px;
      /* padding: 0px 10px 15px 10px; */
      padding: 0px 5px 15px 5px;
      background-color: #ffffff;
      /* &.active {
        background-color: gray;
        .progressGroupRow__summary {
          color: #ffffff;
        }
      } */
      &.MuiAccordion-root {
        box-shadow: none;
        &:before {
          display: none;
        }
        &.Mui-expanded {
          margin: 0;
        }
      }
      .progressGroupRow__summary {
        &.MuiAccordionSummary-root {
          /* display: flex; */
          /* min-height: 50px; */
          min-height: 30px;
          align-items: flex-end;
          padding: 0;
        }
        &.Mui-expanded {
          margin: 0;
        }
        .MuiAccordionSummary-content {
          margin: 0;
          align-items: flex-end;
          justify-content: space-between;
          &.Mui-expanded {
            margin: 0;
          }
        }
      }
      .progressGroupRow__detail_box {
        flex-direction: column;
        /* padding: 5px 0 20px 90px; */
        padding: 0;
        .progressGroupRow__detail {
          margin-top: 5px;
          padding: 5px 10px 5px 5px;
          border-radius: 5px;
          background-color: #f4f5fa;
          .progressGroupRow__detail_title {
            margin: 3px 0 5px 0;
            font-size: 12px;
            font-weight: 700;
            &.upload {
            }
          }
          .progressGroupRow__item_list {
            .progressGroupRow__item_row {
              display: grid;
              grid-template-columns: calc(100% - 40px) 40px;
              min-height: 35px;
              margin-top: 3px;
              /* min-height: 50px; */
              /* padding: 12px 20px 8px; */
              .progressGroupRow__item {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                .progressGroupRow__uploadProgress_bar {
                  width: 100%;
                  height: 12px;
                  background-color: lightgray;
                  margin-bottom: 3px;
                  border-radius: 20px;
                  &.error {
                    background-color: darkgray;
                    border: 1px solid ${color.red};
                  }
                }
                .progressGroupRow__uploadProgress_bar > div {
                  height: 12px;
                  background-color: ${color.blue};
                  border-radius: 20px;
                  transition: width 1s;
                  &.error {
                    background-color: ${color.red};
                  }
                }
                .progressGroupRow__item_error,
                .progressGroupRow__item_name {
                  width: 100%;
                  /* height: 13px; */
                  text-align: left;
                  font-size: 13px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  line-height: 1.1;
                  &.error {
                    color: ${color.red};
                  }
                }
                .progressGroupRow__item_error {
                  color: ${color.red};
                }
              }
              .progressGroupRow__status {
                display: flex;
                align-items: flex-start;
                justify-content: center;
                .progressGroupRow__item_percentage {
                  margin-left: 10px;
                  font-size: 13px;
                }
                .progressGroupRow__error_clear {
                  width: 25px;
                  height: 25px;
                  padding: 5px;
                }
              }
            }
          }
        }

        &.MuiAccordionDetails-root {
        }

        /* .supportListRow__details_content {
          width: 1272px;
          margin-top: 20px;
          margin-left: 50px;
          background-color: #edf4fb;
          padding: 20px;
          border-radius: 0px 15px 15px 15px;
          font-size: 11px;
          font-weight: 400;
          color: #303030;
          line-height: 25px;
        } */
      }
    }
  `,
};
